import React, { useEffect, useRef } from "react";

interface ContentLibraryPickerOverlayProps {
  url: string;
  onCancel: () => void;
}

function ContentLibraryPickerOverlay({ url, onCancel }: ContentLibraryPickerOverlayProps) {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onCancel();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [onCancel]);

  return (
    <div className="portal-overlay">
      <div className="cd-cl-picker">
        <div className="cd-cl-picker__dialog">
          <iframe
            ref={iframeRef}
            title="Content Library"
            src={url}
            className="cd-cl-picker__iframe"
          />
        </div>
      </div>
    </div>
  );
}

export default ContentLibraryPickerOverlay;
